import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import ChartCard from './ChartCard'
import StatTile from './StatTile'
import { formatStatValue } from '../constants'
import { buildGridSx } from '../styles'

export type StatTileItem = {
  key: string
  label: string
  value: number | null | undefined
  suffix?: string
}

type StatTilesCardProps = {
  title: string
  description: string
  tiles: StatTileItem[]
  loading: boolean
  hasError: boolean
}

const StatTilesCard: React.FC<StatTilesCardProps> = ({ title, description, tiles, loading, hasError }) => {
  const { i18n } = useTranslation()
  const columns = tiles.length === 3 ? 3 : 2

  return (
    <ChartCard
      title={title}
      description={description}
      loading={loading}
      hasError={hasError}
      isEmpty={!tiles.some(({ value }) => Number(value) > 0)}
      bodyHeight="auto"
    >
      <Box sx={buildGridSx({ xs: 1, sm: columns }, 1)}>
        {tiles.map(({ key, label, value, suffix }) => (
          <StatTile key={key} label={label} value={formatStatValue(value, i18n.language, suffix)} />
        ))}
      </Box>
    </ChartCard>
  )
}

export default StatTilesCard
